const getImage = (filename) => {
  return require(`../img/commonProducts/${filename}`);
};

export const commonProducts = [
    {
        id: "abb-00000001",
        brand: "ABB",
        category: "Interruptores",
        description: "Disyuntor Diferencial - Varios modelos - ABB",
        image: getImage("ABB-00000001.jpg")
    },
    {
        id: "abb-00000002",
        brand: "ABB",
        category: "Interruptores",
        description: "Llave térmica - Varios modelos - ABB",
        image: getImage("ABB-00000002.jpg")
    },
    {
        id: "arg-00000001",
        brand: "Argenplas",
        category: "Cables",
        description: "Cable unipolar - Varias medidas - por rollo o por metro - Argenplas",
        image: getImage("ARG-00000001.jpg")
    },
    {
        id: "arg-00000002",
        brand: "Argenplas",
        category: "Cables",
        description: "Cable tipo taller - Varias medidas - por metro - Argenplas",
        image: getImage("ARG-00000002.jpg")
    },
    {
        id: "arg-00000003",
        brand: "Argenplas",
        category: "Cables",
        description: "Cable subterráneo - Varias medidas - por metro - Argenplas",
        image: getImage("ARG-00000003.jpg")
    },
    {
        id: "arg-00000004",
        brand: "Argenplas",
        category: "Cables",
        description: "Cable extraflexible para soldaduras - Varias medidas - por metro - Argenplas",
        image: getImage("ARG-00000004.jpg")
    },
    {
        id: "arg-00000005",
        brand: "Argenplas",
        category: "Cables",
        description: "Cable chato bajo plomo - Varias medidas - por metro - Argenplas",
        image: getImage("ARG-00000005.jpg")
    },
    {
        id: "arg-00000006",
        brand: "Argenplas",
        category: "Cables",
        description: "Cable bipolar paralelo - Varias medidas - por metro - Argenplas",
        image: getImage("ARG-00000006.jpg")
    },
    {
        id: "arg-00000007",
        brand: "Argenplas",
        category: "Cables",
        description: "Cable subterráneo libre de halógeno - Varias medidas - por pedido - Argenplas",
        image: getImage("ARG-00000007.jpg")
    },
    {
        id: "arg-00000008",
        brand: "Argenplas",
        category: "Cables",
        description: "Cable conductor desnudo - Varias medidas - por metro - Argenplas",
        image: getImage("ARG-00000008.jpg")
    },
    {
        id: "asa-00000001",
        brand: "Asanno",
        category: "Cablecanal",
        description: "Cablecanal con adhesivo - Varias medidas - Asanno",
        image: getImage("ASA-00000001.jpg")
    },
    {
        id: "ato-00000001",
        brand: "Atomlux",
        category: "Iluminación de emergencia",
        description: "Luz de emergencia compacta 60 LEDs - Atomlux",
        image: getImage("ATO-00000001.jpg")
    },
    {
        id: "baw-00000001",
        brand: "Baw",
        category: "Interruptores",
        description: "Disyuntor Diferencial - Varios modelos - Baw",
        image: getImage("BAW-00000001.jpg")
    },
    {
        id: "baw-00000002",
        brand: "Baw",
        category: "Interruptores",
        description: "Llave térmica - Varios modelos - Baw",
        image: getImage("BAW-00000002.jpg")
    },
    {
        id: "baw-00000003",
        brand: "Baw",
        category: "Iluminación",
        description: "Lámpara LED - Varios modelos - Baw",
        image: getImage("BAW-00000003.jpg")
    },
    {
        id: "cam-00000001",
        brand: "Cambre",
        category: "Llaves de luz",
        description: "Conjunto de bastidor + tapa + interruptor/toma/tapa ciega - Línea SXXII - Cambre",
        image: getImage("CAM-00000001.jpg")
    },
    {
        id: "cle-00000001",
        brand: "Cleos",
        category: "Iluminación de emergencia",
        description: "Luminaria de emergencia con fuente USB - Cleos",
        image: getImage("CLE-00000001.jpg")
    },
    {
        id: "cle-00000002",
        brand: "Cleos",
        category: "Iluminación",
        description: "Proyector IP67 - Línea Superlux - Varios modelos - Cleos",
        image: getImage("CLE-00000002.jpg")
    },
    {
        id: "con-00000001",
        brand: "Conextube",
        category: "Prensacables",
        description: "Prensacable metálico - Varias medidas - Conextube",
        image: getImage("CON-00000001.jpg")
    },
    {
        id: "con-00000002",
        brand: "Conextube",
        category: "Prensacables",
        description: "Tuerca metálica - Varias medidas - Conextube",
        image: getImage("CON-00000002.jpg")
    },
    {
        id: "cpt-00000001",
        brand: "Computel",
        category: "Cables",
        description: "Cable telefónico - Varias medidas - Computel",
        image: getImage("CPT-00000001.jpg")
    },
    {
        id: "cpt-00000002",
        brand: "Computel",
        category: "Cables",
        description: "Cable para portero - Varias medidas - Computel",
        image: getImage("CPT-00000002.jpg")
    },
    {
        id: "cpt-00000003",
        brand: "Computel",
        category: "Cables",
        description: "Cable telefónico subterráneo - Varias medidas - Computel",
        image: getImage("CPT-00000003.jpg")
    },
    {
        id: "day-00000001",
        brand: "Dayton",
        category: "Telefonía y redes",
        description: "Ficha americana RJ45 - Varias medidas - Dayton",
        image: getImage("DAY-00000001.jpg")
    },
    {
        id: "elc-00000001",
        brand: "Elece",
        category: "Bandejas",
        description: "Bandeja portacables perforada liviana - Varias medidas - Elece",
        image: getImage("ELC-00000001.jpg")
    },
    {
        id: "eln-00000001",
        brand: "Elent",
        category: "Borneras",
        description: "Barra de puesta a tierra - Varias medidas - Elent",
        image: getImage("ELN-00000001.jpg")
    },
    {
        id: "eln-00000002",
        brand: "Elent",
        category: "Borneras",
        description: "Barra de distribución - Varias medidas - Elent",
        image: getImage("ELN-00000002.jpg")
    },
    {
        id: "fle-00000001",
        brand: "Flexitub",
        category: "Caños",
        description: "Caño metálico flexible recubierto - Varias medidas - Flexitub",
        image: getImage("FLE-00000001.jpg")
    },
    {
        id: "fui-00000001",
        brand: "Fuinyter",
        category: "Iluminación",
        description: "Artefacto tortuga - Para uso con luz LED - Varios modelos - Fuinyter",
        image: getImage("FUI-00000001.jpg")
    },
    {
        id: "gam-00000001",
        brand: "Gamasonic",
        category: "Iluminación de emergencia",
        description: "Luminaria de emergencia 60 LEDs - Gamasonic",
        image: getImage("GAM-00000001.jpg")
    },
    {
        id: "gcf-00000001",
        brand: "GC",
        category: "Cajas",
        description: "Caja de paso de chapa - Varias medidas - GC",
        image: getImage("GCF-00000001.jpg")
    },
    {
        id: "gel-00000001",
        brand: "General Electric",
        category: "Interruptores",
        description: "Disyuntor Diferencial - Varios modelos - General Electric",
        image: getImage("GEL-00000001.jpg")
    },
    {
        id: "gel-00000002",
        brand: "General Electric",
        category: "Interruptores",
        description: "Llave térmica - Varios modelos - General Electric",
        image: getImage("GEL-00000002.jpg")
    },
    {
        id: "gen-00000001",
        brand: "Genrod",
        category: "Gabinetes",
        description: "Gabinete con puerta fume PVC - Varias medidas - Genrod",
        image: getImage("GEN-00000001.jpg")
    },
    {
        id: "gen-00000002",
        brand: "Genrod",
        category: "Gabinetes",
        description: "Gabinete con contrafrente calado - Varias medidas - Genrod",
        image: getImage("GEN-00000002.jpg")
    },
    {
        id: "gen-00000003",
        brand: "Genrod",
        category: "Gabinetes",
        description: "Gabinete estanco - Varias medidas - Genrod",
        image: getImage("GEN-00000003.jpg")
    },
    {
        id: "gen-00000004",
        brand: "Genrod",
        category: "Gabinetes",
        description: "Gabinete para medidor monofásico - Varias medidas - Genrod",
        image: getImage("GEN-00000004.jpg")
    },
    {
        id: "gen-00000005",
        brand: "Genrod",
        category: "Gabinetes",
        description: "Gabinete para medidor trifásico - Varias medidas - Genrod",
        image: getImage("GEN-00000005.jpg")
    },
    {
        id: "gen-00000006",
        brand: "Genrod",
        category: "Cajas",
        description: "Caja de pase IP65 - Varias medidas - Genrod",
        image: getImage("GEN-00000006.jpg")
    },
    {
        id: "gen-00000007",
        brand: "Genrod",
        category: "Caños",
        description: "Caño semirígido - Varias medidas - Genrod",
        image: getImage("GEN-00000007.jpg")
    },
    {
        id: "hel-00000001",
        brand: "HellermannTyton",
        category: "Cablecanal",
        description: "Unicanal FDC - Varias medidas - HellermannTyton",
        image: getImage("HEL-00000001.jpg")
    },
    {
        id: "jel-00000001",
        brand: "Jeluz",
        category: "Llaves de luz",
        description: "Conjunto de bastidor + tapa + interruptor/toma/tapa ciega - Línea Verona - Jeluz",
        image: getImage("JEL-00000001.jpg")
    },
    {
        id: "lct-00000001",
        brand: "LCT",
        category: "Terminales",
        description: "Terminal SCC - Varias medidas - LCT",
        image: getImage("LCT-00000001.jpg")
    },
    {
        id: "lct-00000002",
        brand: "LCT",
        category: "Terminales",
        description: "Terminal preaislado - Varias medidas - LCT",
        image: getImage("LCT-00000002.jpg")
    },
    {
        id: "lct-00000003",
        brand: "LCT",
        category: "Terminales",
        description: "Unión UCC - Varias medidas - LCT",
        image: getImage("LCT-00000003.jpg")
    },
    {
        id: "lct-00000004",
        brand: "LCT",
        category: "Terminales",
        description: "Pin con aislación CTN - Varias medidas - LCT",
        image: getImage("LCT-00000004.jpg")
    },
    {
        id: "man-00000001",
        brand: "Manguelec",
        category: "Caños",
        description: "Caño manguera azul - Rollo 25 mts - Manguelec",
        image: getImage("MAN-00000001.jpg")
    },
    {
        id: "mic-00000001",
        brand: "Micro Control",
        category: "Caños",
        description: "Caño flexible MF - Varias medidas - Micro Control",
        image: getImage("MIC-00000001.jpg")
    },
    {
        id: "mic-00000002",
        brand: "Micro Control",
        category: "Conectores",
        description: "Conector recto FT - Varias medidas - Micro Control",
        image: getImage("MIC-00000002.jpg")
    },
    {
        id: "mic-00000003",
        brand: "Micro Control",
        category: "Caños",
        description: "Caño galvanizado DAISA - Varias medidas - Micro Control",
        image: getImage("MIC-00000003.jpg")
    },
    {
        id: "mon-00000001",
        brand: "Montero",
        category: "Contactores",
        description: "Contactor MC2 - Varias medidas - Montero",
        image: getImage("MON-00000001.jpg")
    },
        {
        id: "mon-00000002",
        brand: "Montero",
        category: "Guardamotores",
        description: "Guardamotor Línea MG1 - Varios modelos - Montero",
        image: getImage("MON-00000002.jpg")
    },
    {
        id: "mon-00000003",
        brand: "Montero",
        category: "Contactores",
        description: "Relevo térmico Línea TR1 - Varios modelos - Montero",
        image: getImage("MON-00000003.jpg")
    },
    {
        id: "mul-00000001",
        brand: "Multimarca",
        category: "Grampas",
        description: "Grampa OMEGA - Varias medidas - Multimarca",
        image: getImage("MUL-00000001.jpg")
    },
    {
        id: "mul-00000002",
        brand: "Multimarca",
        category: "Grampas",
        description: "Grampa 1/2 OMEGA - Varias medidas - Multimarca",
        image: getImage("MUL-00000002.jpg")
    },
    {
        id: "nov-00000001",
        brand: "Nova",
        category: "Iluminación",
        description: "Artefacto LED Exterior Redondo - Varios modelos - Nova",
        image: getImage("NOV-00000001.jpg")
    },
    {
        id: "nov-00000002",
        brand: "Nova",
        category: "Iluminación",
        description: "Artefacto LED Exterior Cuadrado - Varios modelos - Nova",
        image: getImage("NOV-00000002.jpg")
    },
    {
        id: "nov-00000003",
        brand: "Nova",
        category: "Iluminación",
        description: "Lámpara LED AR111 - Varios modelos - Nova",
        image: getImage("NOV-00000003.jpg")
    },
    {
        id: "nov-00000004",
        brand: "Nova",
        category: "Iluminación",
        description: "Lámpara LED Alta Potencia - Varios modelos - Nova",
        image: getImage("NOV-00000004.jpg")
    },
    {
        id: "nov-00000005",
        brand: "Nova",
        category: "Iluminación",
        description: "Lámpara LED Bipin - Varios modelos - Nova",
        image: getImage("NOV-00000005.jpg")
    },
    {
        id: "nov-00000006",
        brand: "Nova",
        category: "Iluminación",
        description: "Lámpara LED Vela ECO - Varios modelos - Nova",
        image: getImage("NOV-00000006.jpg")
    },
    {
        id: "nov-00000007",
        brand: "Nova",
        category: "Iluminación",
        description: "Lámpara LED Dicroica - Varios modelos - Nova",
        image: getImage("NOV-00000007.jpg")
    },
    {
        id: "nov-00000008",
        brand: "Nova",
        category: "Iluminación",
        description: "Lámpara LED Gota ECO - Varios modelos - Nova",
        image: getImage("NOV-00000008.jpg")
    },
    {
        id: "nov-00000009",
        brand: "Nova",
        category: "Iluminación",
        description: "Listón para tubo LED - Varios modelos - Nova",
        image: getImage("NOV-00000009.jpg")
    },
    {
        id: "nov-00000010",
        brand: "Nova",
        category: "Iluminación",
        description: "Panel LED - Varios modelos - Nova",
        image: getImage("NOV-00000010.jpg")
    },
    {
        id: "nov-00000011",
        brand: "Nova",
        category: "Iluminación",
        description: "Lámpara LED Magnolia - Varios modelos - Nova",
        image: getImage("NOV-00000011.jpg")
    },
    {
        id: "nov-00000012",
        brand: "Nova",
        category: "Iluminación",
        description: "Proyector LED - Varios modelos - Nova",
        image: getImage("NOV-00000012.jpg")
    },
    {
        id: "nue-00000001",
        brand: "Nueve de Julio",
        category: "Cajas",
        description: "Caja rectangular de chapa - Nueve de Julio",
        image: getImage("NUE-00000001.jpg")
    },
    {
        id: "nue-00000002",
        brand: "Nueve de Julio",
        category: "Conectores",
        description: "Conectores - Varias medidas - Nueve de Julio",
        image: getImage("NUE-00000002.jpg")
    },
    {
        id: "per-00000001",
        brand: "Percan",
        category: "Portalámparas",
        description: "Portalámpara con chicote - Percan",
        image: getImage("PER-00000001.jpg")
    },
    {
        id: "per-00000002",
        brand: "Percan",
        category: "Tomas",
        description: "Toma capsulado exterior azul - Percan",
        image: getImage("PER-00000002.jpg")
    },
    {
        id: "per-00000003",
        brand: "Percan",
        category: "Prensacables",
        description: "Prensacable PVC - Varias medidas - Percan",
        image: getImage("PER-00000003.jpg")
    },
    {
        id: "pri-00000001",
        brand: "Priolo",
        category: "Jabalinas",
        description: "Caja de insprección para jabalina PVC - Varias medidas - Priolo",
        image: getImage("PRI-00000001.jpg")
    },
    {
        id: "pri-00000002",
        brand: "Priolo",
        category: "Jabalinas",
        description: "Jabalina con tomacable - Varias medidas - Priolo",
        image: getImage("PRI-00000002.jpg")
    },
    {
        id: "pro-00000001",
        brand: "Commscope",
        category: "Fichas",
        description: "Jack RJ45 - Varias medidas - Commscope",
        image: getImage("PRO-00000001.jpg")
    },
    {
        id: "ric-00000001",
        brand: "Richi",
        category: "Zapatillas",
        description: "Zapatilla con térmico - Provetel",
        image: getImage("RIC-00000001.jpg")
    },
    {
        id: "mge-00000001",
        brand: "Schneider Electric",
        category: "Interruptores",
        description: "Disyuntor Diferencial - Varios modelos - Schneider Electric",
        image: getImage("MGE-00000001.jpg")
    },
    {
        id: "mge-00000002",
        brand: "Schneider Electric",
        category: "Interruptores",
        description: "Llave térmica - Varios modelos - Schneider Electric",
        image: getImage("MGE-00000002.jpg")
    },
    {
        id: "syb-00000001",
        brand: "Sybyd",
        category: "Precintos",
        description: "Precintos - Varias medidas - Por bolsa de 100u. - Sybyd",
        image: getImage("SYB-00000001.jpg")
    },
    {
        id: "tab-00000001",
        brand: "Tableplast",
        category: "Gabinetes",
        description: "Gabinete de polipropileno - Varias medidas - Tableplast",
        image: getImage("TAB-00000001.jpg")
    },
    {
        id: "tab-00000002",
        brand: "Tableplast",
        category: "Gabinetes",
        description: "Gabinete de polipropileno exterior azul - Varias medidas - Tableplast",
        image: getImage("TAB-00000002.jpg")
    },
    {
        id: "sas-00000001",
        brand: "TBCin",
        category: "Contactores",
        description: "Contactor AC3 - Varias medidas - TBCin",
        image: getImage("SAS-00000001.jpg")
    },
    {
        id: "sas-00000002",
        brand: "TBCin",
        category: "Guardamotores",
        description: "Guardamotor Línea SMD8 - TBCin",
        image: getImage("SAS-00000002.jpg")
    },
    {
        id: "sas-00000003",
        brand: "TBCin",
        category: "Contactores",
        description: "Rele térmico - Varias medidas - TBCin",
        image: getImage("SAS-00000003.jpg")
    },
    {
        id: "tcn-00000001",
        brand: "Tecnova",
        category: "Fichas",
        description: "Ficha macho IP44 - Varios modelos - Tecnova",
        image: getImage("TCN-00000001.jpg")
    },
    {
        id: "tcn-00000002",
        brand: "Tecnova",
        category: "Tomas",
        description: "Toma para embutir - Varios modelos - Tecnova",
        image: getImage("TCN-00000002.jpg")
    },
    {
        id: "tcn-00000003",
        brand: "Tecnova",
        category: "Tomas",
        description: "Toma hembra IP44 - Varios modelos - Tecnova",
        image: getImage("TCN-00000003.jpg")
    },
    {
        id: "tec-00000001",
        brand: "Tecnocom",
        category: "Caños",
        description: "Caño corrugado - Rollo 25mts - Tecnocom",
        image: getImage("TEC-00000001.jpg")
    },
    {
        id: "tec-00000002",
        brand: "Tecnocom",
        category: "Caños",
        description: "Caño rígido - Varias medidas - Tecnocom",
        image: getImage("TEC-00000002.jpg")
    },
    {
        id: "zol-00000001",
        brand: "Zoloda",
        category: "Bornes",
        description: "Borne poliamida BPN - Varios modelos - Zoloda",
        image: getImage("ZOL-00000001.jpg")
    },
    {
        id: "zol-00000002",
        brand: "Zoloda",
        category: "Bornes",
        description: "Borne puesta a tierra - Varios modelos - Zoloda",
        image: getImage("ZOL-00000002.jpg")
    },
    {
        id: "zol-00000003",
        brand: "Zoloda",
        category: "Cablecanal",
        description: "Cablecanal calado - Varias medidas - Zoloda",
        image: getImage("ZOL-00000003.jpg")
    },
    {
        id: "zol-00000004",
        brand: "Zoloda",
        category: "Rieles",
        description: "Riel DIN - Varias medidas - Zoloda",
        image: getImage("ZOL-00000004.jpg")
    },
];
